function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useMemo } from "react";
import moment from "moment-timezone";
import DatePicker from "react-datepicker";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import "./ProjectReport.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { arrayToStringOutput, stringToArrayOutput } from "./../SideMenu/Header";
var filterOptions = ["Today", "This Week", "Yesterday", "This Month", "Last 7 Days", "Last Month", "Last Week", "Custom"];
export function TimeFilter(props) {
  var onFilterChange = props.onFilterChange,
    onClose = props.onClose,
    organisationBilling = props.organisationBilling,
    organisationSettings = props.organisationSettings;
  var _React$useState = React.useState({
      startDate: props.startDate,
      endDate: props.endDate
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dates = _React$useState2[0],
    setDates = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    customMemberError = _React$useState4[0],
    setCustomMemberError = _React$useState4[1];
  var _ref = dates || {},
    startDate = _ref.startDate,
    endDate = _ref.endDate;
  var _React$useState5 = React.useState(props.filterData),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    filterData = _React$useState6[0],
    setFilterData = _React$useState6[1];
  React.useEffect(function () {
    setDates({
      startDate: props.startDate,
      endDate: props.endDate
    });
    setFilterData(props.filterData);
  }, [props.startDate, props.endDate]);
  var handleDateChange = function handleDateChange(date) {
    var _date = _slicedToArray(date, 2),
      startDate = _date[0],
      endDate = _date[1];
    setCustomMemberError(null);
    var diffInDays = 0;
    if (startDate && endDate) {
      var startDateMoment = moment(startDate);
      var endDateMoment = moment(endDate);
      diffInDays = endDateMoment.diff(startDateMoment, "days") + 1;
    }
    if (diffInDays > 31) {
      setCustomMemberError("Maximum 31 days can be selected at once. Please select the remaining dates separately.");
    }
    setDates({
      startDate: startDate,
      endDate: endDate
    });
    setFilterData(arrayToStringOutput(date, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone));
  };
  var handleFilterButtonClick = function handleFilterButtonClick(filter) {
    setFilterData(filter);
    var _stringToArrayOutput = stringToArrayOutput(filter, organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone),
      _stringToArrayOutput2 = _slicedToArray(_stringToArrayOutput, 2),
      startDate = _stringToArrayOutput2[0],
      endDate = _stringToArrayOutput2[1];
    setDates({
      startDate: startDate,
      endDate: endDate
    });
  };
  var handleFilterChange = function handleFilterChange(dates) {
    return function () {
      onFilterChange(dates);
      onClose();
    };
  };
  var datePickerMinDate = stringToArrayOutput("Last 14 Days", organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-datepicker"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    inline: true,
    selected: startDate,
    onChange: handleDateChange,
    startDate: startDate,
    endDate: endDate,
    minDate: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName) == "free" || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" ? datePickerMinDate[0] : "",
    selectsRange: (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) == "stopped" ? false : true
  })), /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier"
  }, /*#__PURE__*/React.createElement("p", null, "Filter by Period"), /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier-listing"
  }, filterOptions.map(function (value) {
    return /*#__PURE__*/React.createElement(FilterButton, {
      key: value,
      onFilterButtonClick: handleFilterButtonClick,
      isSelected: value === filterData ? true : value === "Custom" && filterOptions.includes(filterData) === false ? true : false,
      value: value,
      planName: organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planName
    });
  }))))), customMemberError ? /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-custom-member-filter-error-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-custom-member-filter-error"
  }, customMemberError), /*#__PURE__*/React.createElement("div", null)) : null, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-button"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "page-content-wrapper-menu-filter-overlay-button-cancel",
    variant: "outline-primary",
    onClick: function onClick() {
      setCustomMemberError(null);
      onClose();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "project-report-apply-button",
    onClick: customMemberError != null ? null : handleFilterChange(dates),
    disabled: customMemberError != null
  }, "Apply")));
}
function FilterButton(_ref2) {
  var value = _ref2.value,
    isSelected = _ref2.isSelected,
    onFilterButtonClick = _ref2.onFilterButtonClick,
    planName = _ref2.planName;
  var handleFilterButtonClick = function handleFilterButtonClick(value) {
    return function () {
      onFilterButtonClick(value);
    };
  };
  return planName == "free" && (value == "Last Month" || value == "This Month" || value == "Custom") ? /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, {
      id: "tooltip-bottom",
      className: "count-tooltip-start"
    }, "Please upgrade the plan to see your old data")
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-content-wrapper-menu-filter-overlay-list-contanier-listing-card filter-menu-disabled"
  }, value)) : /*#__PURE__*/React.createElement("button", {
    className: classNames("page-content-wrapper-menu-filter-overlay-list-contanier-listing-card", {
      "filter-menu-active": isSelected,
      "filter-menu-disabled": planName == "free" && (value == "Last Month" || value == "Custom")
    }),
    onClick: handleFilterButtonClick(value)
  }, value);
}